import DOMPurify from 'dompurify';
import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: true });

/**
 * 마크다운 → HTML.
 *
 * 본문은 사용자가 쓴 것이므로 **반드시 새니타이즈한다.** 사내 도구라도 예외가 아니다.
 * 로그인한 동료가 쓴 글에 스크립트가 섞이면 세션 쿠키는 httpOnly라 직접 못 읽어도
 * 그 사람 권한으로 API를 부르는 건 가능하다.
 */
export function renderMarkdown(bodyMd: string): string {
  const raw = marked.parse(bodyMd, { async: false });
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'del', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'blockquote', 'code', 'pre', 'hr', 'img',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    ALLOWED_ATTR: ['href', 'title', 'src', 'alt'],
    // javascript:, data: 스킴 차단
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|#|\/)/i,
  });
}

/** 상대 시간. "3분 전"처럼 짧게 보여주고, 오래된 건 날짜로. */
export function formatWhen(iso: string): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '';

  const diffSec = Math.floor((Date.now() - then.getTime()) / 1000);

  if (diffSec < 60) return '방금';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}분 전`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}시간 전`;
  if (diffSec < 86400 * 7) return `${Math.floor(diffSec / 86400)}일 전`;

  const sameYear = then.getFullYear() === new Date().getFullYear();
  return then.toLocaleDateString('ko-KR', {
    year: sameYear ? undefined : 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
